<template>
    <fieldset>
        Filter: <input type="search" v-model="searchText" v-on:keyup.enter="searchUsers()" />
        &nbsp;<button type="button" @click="searchUsers()">Search</button>
        <table>
            <caption>Users</caption>
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th :class="getHeaderClasses('Username')" @click="sort('Username')">Username</th>
                    <th :class="getHeaderClasses('First Name')" @click="sort('First Name')">First Name</th>
                    <th :class="getHeaderClasses('Last Name')" @click="sort('Last Name')">Last Name</th>
                    <th :class="getHeaderClasses('Company')" @click="sort('Company')">Company</th>
                    <th :class="getHeaderClasses('Confirmed Email')" @click="sort('Confirmed Email')">Confirmed Email</th>
                    <th :class="getHeaderClasses('Date Registered')" @click="sort('Date Registered')">Date Registered</th>
                    <th :class="getHeaderClasses('Last Login')" @click="sort('Last Login')">Last Login</th>
                    <th :class="getHeaderClasses('Status')" @click="sort('Status')">Status</th>
                    <th :class="getHeaderClasses('Support Network')" @click="sort('Support Network')">Network</th>
                    <th class="Options">Options</th>
                </tr>
            </thead>
            <tbody v-if="Users !== null">
                <tr v-for="(user, index) in SortedAndFilteredUsers" :key="user.id">
                    <td>{{index + 1}}</td>
                    <td>{{user.userName}}</td>
                    <td>{{user.firstName}}</td>
                    <td>{{user.lastName}}</td>
                    <td>{{user.organisationName}}</td>
                    <td v-bind:class="user.emailConfirmed ? 'Positive' : 'Negative'">{{user.emailConfirmed}}</td>
                    <td>{{displayDate(user.dateRegistered)}}</td>
                    <td>{{displayDate(user.lastLogin)}}</td>
                    <td v-bind:class="'Status' + user.userStatus">{{getStatusText(user.userStatus)}}</td>
                    <td>{{user.supportNetwork}}</td>
                    <td class="Options">
                        <button @click="manageUser(user.id)">Manage</button>
                        <button @click="addNote(user.id)">Add Note</button>
                        <button v-bind:disabled="user.noteCount === 0" v-bind:title="GetNotesToolTip(user.noteCount)" @click="viewNotes(user.id)">View Notes</button>
                        <button class="destructive" @click="deleteUser(user)">Delete</button>
                    </td>
                </tr>
            </tbody>
            <tbody v-if="loading || !nextPage">
                <tr>
                    <td colspan="11" class="LoadingCell">
                        <span v-if="loading">
                            <loading-indicator /> Loading Users
                        </span>
                        <span v-else>
                            No more results
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <button type="button" v-if="!!nextPage" @click="getNextPage()" :disabled="loading">Load more</button>
        <user v-if="selectedUserId !== null" :userId.sync="selectedUserId" />
        <userNotes v-if="IsUserNotesVisible === true" :user-notes="selectedUserNotes" v-on:user-notes-cancelled="IsUserNotesVisible = false" />
    </fieldset>
</template>

<script>
    import LoadingIndicator from './LoadingIndicator.vue';
    import User from './User.vue';
    import UserNotes from './UserNotes.vue';
    import $ from 'jquery';

    export default {
        name: 'Users',
        props: ["Type"],
        components: {
            LoadingIndicator,
            User,
            UserNotes
        },
        watch: {
            selectedUserId: function (newValue, oldValue) {
                if (newValue === null && oldValue !== null)
                    this.nextPage = 1;
                    this.refreshUsers();
            }
        },
        data: function () {
            return {
                Users: null,
                nextPage: 1,
                searchText: "",
                sortBy: "Date Registered",
                sortOrder: "Desc",
                selectedUserId: null,
                IsUserNotesVisible: false,
                selectedUserNotes: [],
                loading: false,
            }
        },
        created: function () {
            if (window.location.hash !== null && window.location.hash.length > 1) {
                this.selectedUserId = window.location.hash.substr(1);
                window.location.hash = "";
            }
            this.refreshUsers();
        },
        methods: {
            "sort": function (columnReference) {
                this.sortBy = columnReference
                this.sortOrder = this.sortBy === columnReference
                    ? this.sortOrder === "Desc" ? "Asc" : "Desc"
                    : "Asc";
                this.nextPage = 1;
                this.refreshUsers();
            },
            "manageUser": function (userId) {
                this.selectedUserId = userId;
            },
            "getHeaderClasses": function (columnReference) {
                var result = ["sortable"];
                if (this.sortBy === columnReference)
                    result.push(this.sortOrder);
                return result;
            },
            "refreshUsers": function () {
                var myComponent = this;
                var currentPage = myComponent.nextPage;
                var type = myComponent.Type == "Rejected" ? "Rejected" : "Users";
                myComponent.loading = true;
                $.ajax({
                    type: 'GET',
                    url: `LocalUsers/ByType/${type}?sort=${this.sortBy}&sortOrder=${this.sortOrder}&search=${this.searchText}&page=${currentPage}`,
                    dataType: 'json',
                    success: function (data) {
                        if (currentPage === 1) {
                            myComponent.Users = data.users;
                        } else {
                            myComponent.Users.push(...data.users);
                        }
                        myComponent.nextPage = data.nextPage;
                    },
                    complete: function () {
                        myComponent.loading = false;
                    },
                });
            },
            searchUsers: function () {
                this.nextPage = 1;
                this.refreshUsers();
            },
            getNextPage: function () {
                if (this.nextPage) {
                    this.refreshUsers();
                }
            },
            displayDate: function (d) {
                if (d === null)
                    return "-";
                return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
            },
            getStatusText: function (status) {
                if (status === 0)
                    return "Awaiting Approval";
                if (status === 1)
                    return "Approved";
                if (status === 2)
                    return "Rejected";
                if (status === 3)
                    return "Bulk Registered";
                if (status === 4)
                    return "Pre-Approved";
            },
            "addNote": function (userId) {
                var thisControl = this;
                var vNote = prompt("Enter Note:");
                if (vNote != null && vNote != undefined && vNote != "") {
                    $.ajax({
                        type: 'PUT',
                        url: "/Settings/AddNote" + "/" + userId,
                        data: JSON.stringify(vNote),
                        contentType: 'application/json',
                        dataType: 'json',
                        error: function (xhr) {
                            thisControl.Saving = false;
                            alert("Error saving:" + xhr.responseText);
                        },
                        success: function () {
                            this.nextPage = 1;
                            thisControl.refreshUsers();
                        }
                    });
                }
            },
            "viewNotes": function (userId) {
                var thisControl = this;

                $.ajax({
                    type: 'GET',
                    url: "/Settings/ViewNotes" + "/" + userId,
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.IsUserNotesVisible = true;
                        thisControl.selectedUserNotes = data;
                    },
                    error: function (xhr) {
                        alert("Error Retrieving user note':" + xhr.responseText);
                    }
                });
            },
            GetNotesToolTip: function (count) {
                if (count > 0)
                    return count + " Note's";
                else
                    return "";
            },
            deleteUser: function (user) {
                var thisControl = this;
                var response = prompt("Please confirm Delete\nTo delete " + user.firstName + " " + user.lastName + ", please type DELETE below:");
                if (response === "DELETE") {
                    thisControl.Users = null;
                    fetch("/LocalUsers/" + user.id, {
                        method: 'DELETE',
                        headers: {
                            'Content-type': 'application/json'
                        }
                    })
                        .then(function (response) {
                            if (response.ok) {
                                this.nextPage = 1;
                                thisControl.refreshUsers();
                            }
                            else {
                                response.json().then(function (error) {
                                    alert("Error deleting User:\n" + error.detail);
                                    this.nextPage = 1;
                                    thisControl.refreshUsers();
                                });
                            }
                        });

                }
                else {
                    alert("Delete Cancelled");
                }
            }
        },
        computed: {
            SortedAndFilteredUsers: function () {
                return this.Users || [];
            }
        }
    }
</script>
<style>
    table td.Options button.destructive {
        background: #bc2525;
    }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->